import SharedMessagesV2 from "@/components/shared/MessagesV2";
export default function LenderMessages() {
  return <SharedMessagesV2 role="lender" />;
}